export const SUCCESSFUL_STATUS_CODE = 200;
export const INTERNAL_ERROR_STATUS_CODE = 500;
export const NOT_FOUND_STATUS_CODE = 404;
export const REDIRECT_STATUS_CODE = 301;
